module.exports = __webpack_public_path__ + "img/icon-scroll-down.3151084b.svg";